// Obtener el carousel mediante su ID
var carousel = document.getElementById("carouselExampleFade");

// Crear un nuevo objeto Carousel de Bootstrap con las opciones adecuadas
var carouselObj = new bootstrap.Carousel(carousel, {
  interval: 2000, // Cambiar cada 2 segundos
  pause: true, // Iniciar pausado
  ride: false, // No iniciar automáticamente
  wrap: true, // Volver al primer slide después de llegar al último
  keyboard: true, // Permitir navegar con el teclado
  touch: true, // Permitir navegar con gestos táctiles
  slide: true, // Activar la transición fade
});

// Obtener el div con el ID "projectRewards"
var projectRewards = document.getElementById("projectRewards");

// Activar el carousel cuando se entra en el div "projectRewards"
projectRewards.addEventListener("mouseenter", function () {
  carouselObj.next(); // Cambiar a la siguiente imagen
});

// Detener el carousel cuando se sale del div "projectRewards"
projectRewards.addEventListener("mouseleave", function () {
  carouselObj.pause();
  carouselObj.to(0); // Volver al primer slide
});
// Cambiar el slide actual cuando se mueve el cursor dentro de "projectRewards"

projectRewards.addEventListener("mousemove", function (event) {
  // Obtener la posición del cursor en relación con el div "projectRewards"
  var x = event.clientX - projectRewards.offsetLeft;
  var y = event.clientY - projectRewards.offsetTop;

  // Verificar si el cursor está dentro del div "projectRewards"
  if (
    x > 0 &&
    x < projectRewards.offsetWidth &&
    y > 0 &&
    y < projectRewards.offsetHeight
  ) {
    carouselObj.next(); // Cambiar al siguiente slide
  }
});

/* funciones para reproducir los videos automáticamente */
var autoplayVideo = function (modal) {
  // Look for a YouTube, Vimeo, or HTML5 video in the modal
  var video = modal.querySelector(
    'iframe[src*="www.youtube.com"], iframe[src*="player.vimeo.com"], video'
  );

  // Bail if the modal doesn't have a video
  if (!video) return;

  // If an HTML5 video, play it
  if (video.tagName.toLowerCase() === "video") {
    video.play();
    return;
  }

  video.src =
    video.src + (video.src.indexOf("?") < 0 ? "?" : "&") + "autoplay=1";
};

/**
 * Stop a YouTube, Vimeo, or HTML5 video
 * @param  {Node} modal  The modal to search inside
 */
var stopVideo = function (modal) {
  // Look for a YouTube, Vimeo, or HTML5 video in the modal
  var video = modal.querySelector(
    'iframe[src*="www.youtube.com"], iframe[src*="player.vimeo.com"], video'
  );

  // Bail if the modal doesn't have a video
  if (!video) return;

  // If an HTML5 video, pause it
  if (video.tagName.toLowerCase() === "video") {
    video.pause();
    return;
  }

  // Remove autoplay from video src
  video.src = video.src.replace("&autoplay=1", "").replace("?autoplay=1", "");
};

/* Código para interceptar el id del modal abierto y cerrarlo a posteriori al hacer click */
// Obtener todos los elementos con el atributo data-bs-toggle="modal"
const modalTriggers = document.querySelectorAll('[data-bs-toggle="modal"]');

// Recorrer los elementos y añadir un evento clic a cada uno
modalTriggers.forEach(function (trigger) {
  trigger.addEventListener("click", function () {
    // Obtener el valor del atributo data-bs-target
    const target = this.getAttribute("data-bs-target");
    const modalId = target.substring(1);

    // Buscar el elemento de video dentro del modal
    const modalEl = document.getElementById(modalId);
    const videos = modalEl.querySelectorAll("video");

    // Reproducir el primer video si existe
    if (videos.length > 0) {
      const video = videos[0];
      video.play();
    }

    // Obtener el elemento de fondo del modal
    const backdrop = document.getElementById(modalId);

    // Añadir evento clic al fondo para cerrar el modal
    backdrop.addEventListener("click", function () {
      const myModalEl = document.getElementById(modalId);
      const modal = bootstrap.Modal.getInstance(myModalEl);

      modal.hide();
    });
  });
});

(function () {
  var current = location.pathname.split("/")[1];
  if (current === "") return;
  var menuItems = document.querySelectorAll(".nav-item a");
  for (var i = 0, len = menuItems.length; i < len; i++) {
    if (menuItems[i].getAttribute("href").indexOf(current) !== -1) {
      menuItems[i].className += " activeNavLink";
    }
  }
  var menuItems = document.querySelectorAll(".logosFooter a");
  for (var i = 0, len = menuItems.length; i < len; i++) {
    if (menuItems[i].getAttribute("href").indexOf(current) !== -1) {
      menuItems[i].className += " activeFooterLink";
    }
  }
})();
